import {
  IPhieuXuatKhoResponseBase,
  IRoleResponseBase,
  ReceiptBaseResponse,
} from '@/core/interfaces/ApiResponses';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { useEnv } from '@/core/hooks/useEnv';
import { PhieuNhapXuatStatusEnum } from '../enums/phieuNhapXuatStatus.enum';
import { evaluatePermission } from '@/core/helpers/checkAbility';
import { hasAdminRole } from '@/core/helpers/authorization-utils';
import { PHIEU_XUAT_KHO } from '@/core/constants/permissions';
import store from '@/store';

const usePhieuXuat = () => {
  const { push } = useRouterCustom();

  const { allowUpdateTaiKhoanPhieuXuatKhac } = useEnv();

  const goToEditPhieuXuatLink = async (
    phieuXuatData: IPhieuXuatKhoResponseBase | ReceiptBaseResponse
  ) => {
    const { id, loai_phieu } = phieuXuatData;

    if (phieuXuatData.id_bien_ban_giai_the === 0 && loai_phieu === 2) {
      await push(`/quan-ly/phieu-xuat-kho/thu-hoi/cap-nhat/${id}`);

      return;
    }

    if (phieuXuatData.id_bien_ban_giai_the === 0 && loai_phieu === 1) {
      await push(`/quan-ly/phieu-xuat-kho/phieu-xuat-khac/cap-nhat/${id}`);

      return;
    }

    await push(`/quan-ly/phieu-xuat-kho/cap-nhat/${id}`);
  };

  const canEditByAuthz = (
    phieuXuatData: IPhieuXuatKhoResponseBase | ReceiptBaseResponse
  ) => {
    const roles = (store.getters.roles as IRoleResponseBase[] | undefined) || [];
    const roleNames = roles.map((role) => role.name);

    // Admin can edit all tickets
    if (hasAdminRole(roleNames)) {
      return true;
    }

    // Non-admin with data:pxk:sua can edit all tickets (no owner check)
    if (evaluatePermission({ value: PHIEU_XUAT_KHO.SUA })) {
      return true;
    }

    // Non-admin without sua: only owner tickets via can_edit
    return phieuXuatData.can_edit === true;
  };

  const isPhieuXuatEditable = (
    phieuXuatData: IPhieuXuatKhoResponseBase | ReceiptBaseResponse
  ) => {
    if (!phieuXuatData) return false;

    if (phieuXuatData.processing_status !== PhieuNhapXuatStatusEnum.PENDING) {
      return false;
    }

    const statusAllowsEdit = !(
      phieuXuatData.is_approved ||
      phieuXuatData.hoan_thanh ||
      phieuXuatData.ngay_hoan_thanh
    );

    if (!statusAllowsEdit) {
      return false;
    }

    return canEditByAuthz(phieuXuatData);
  };

  const allowEditingTaiKhoan = (
    phieuXuatData: IPhieuXuatKhoResponseBase | ReceiptBaseResponse
  ) => {
    if (!phieuXuatData) return true;

    return (
      phieuXuatData.id_bien_ban_giai_the === 0 &&
      allowUpdateTaiKhoanPhieuXuatKhac.value
    );
  };

  return {
    allowEditingTaiKhoan,
    goToEditPhieuXuatLink,
    isPhieuXuatEditable,
  };
};

export default usePhieuXuat;
